var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.currentComponent)?_c(_vm.currentComponent.component,_vm._b({tag:"component"},'component',_vm.currentComponent.props,false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }